export const DEFAULT_LANGUAGE = 'en' as const;

// Known identifiers and self-native labels do not imply production enablement.
export const UI_LANGUAGE_METADATA = {
  en: { nativeLabel: 'English' },
  'zh-HK': { nativeLabel: '繁體中文（香港）' },
} as const;
export type KnownUiLanguage = keyof typeof UI_LANGUAGE_METADATA;

export const ENABLED_UI_LANGUAGES = [DEFAULT_LANGUAGE, 'zh-HK'] as const satisfies readonly KnownUiLanguage[];
export type EnabledUiLanguage = (typeof ENABLED_UI_LANGUAGES)[number];

// The future selector reads these choices and calls setUiLanguage() only.
export const UI_LANGUAGE_OPTIONS: readonly { language: EnabledUiLanguage; nativeLabel: string }[] =
  ENABLED_UI_LANGUAGES.map(language => ({ language, ...UI_LANGUAGE_METADATA[language] }));

export function resolveUiLanguage(value: unknown): EnabledUiLanguage {
  return ENABLED_UI_LANGUAGES.find(language => language === value) ?? DEFAULT_LANGUAGE;
}
